import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';

//TODO
// Fonts
import '@fontsource-variable/playfair-display';
import '@fontsource-variable/raleway';
import '@fontsource/jetbrains-mono';

// i18n (must init before App)
import './i18n';

import App from './App';
import { queryClient } from './api/queryClient';
import useAuthStore from './stores/authStore';
import { unregisterAndCleanup } from './service-worker-registration';

// ---------------------------------------------------------------------------
// Legacy localStorage migration (can be removed in a future release once all
// users have run this code path at least once).
// Seeds the Zustand authStore from old raw-localStorage keys, then removes
// them so the migration is a one-time operation.
// ---------------------------------------------------------------------------
const legacyToken = localStorage.getItem('token');
const hasPersistedAuthState = Boolean(localStorage.getItem('dineo-auth'));
if (legacyToken && !hasPersistedAuthState && !useAuthStore.getState().token) {
  useAuthStore.getState().setAuth({
    token: legacyToken,
    user: { accountType: 'STAFF' },
    restaurantName: localStorage.getItem('restaurantName'),
  });
}
// Remove legacy keys regardless — Zustand store is the single source of truth
localStorage.removeItem('token');
localStorage.removeItem('role');
localStorage.removeItem('restaurantId');
localStorage.removeItem('restaurantName');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Remove the old caching service worker from existing users' browsers
unregisterAndCleanup();
